import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import LeagueInfoWidget from '../League/Widgets/LeagueInfo';
import UserInfoWidget from './Widgets/UserInfo';

const UserSupport = () => (
  <div id="user-support">
    <header className="content-header">
      <h1>
        User
        <small>support</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-life-saver" /> Support
        </li>
        <li className="text-bold">
          <Link to="/user-support">User</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <div className="row">
        <div className="col-md-6">
          <LeagueInfoWidget />
        </div>
        <div className="col-md-6">
          <UserInfoWidget />
        </div>
      </div>
    </section>
  </div>
);

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(UserSupport);



// WEBPACK FOOTER //
// ./src/pages/Support/User/index.js